export enum DocumentContentTab {
  FOLDERS = 'folders',
  DOCUMENTS = 'documents',
  OLD_VERSIONS = 'old_versions',
  ARCHIVED = 'archived',
}

export enum DocumentNavigationTab {
  IN_PROGRESS = 'in_progress',
  OLD_VERSIONS = 'old_versions',
  ARCHIVED = 'archived',
}
